import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import {
  editLogin,
  editPassword,
  signInAsync,
  clearServerErrors
} from '../../../redux/actions/auth';

import RequireUnauth from "../../layout/HOC/require-unauth";
import AuthPhoneModal from "../../ui/Modals/AuthPhoneModal";

import "./LoginPage.scss";

const mapStateToProps = state => ({
  ...state.auth,
});

const mapDispatchToProps = dispatch => ({
  editLogin: value => dispatch(editLogin(value)),
  editPassword: value => dispatch(editPassword(value)),
  onSubmit: (login, password) => dispatch(signInAsync(login, password)),
  clearServerErrors: () => dispatch(clearServerErrors()),
});

class LoginPage extends Component {
  static propTypes = {
    login: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    editLogin: PropTypes.func.isRequired,
    editPassword: PropTypes.func.isRequired,
    serverError: PropTypes.bool.isRequired,
    loginError: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    clearServerErrors: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      formWasSent: false,
      validError: false,
      errorText: '',
    };
  }

  componentDidMount = () => {
    const { clearServerErrors } = this.props;
    clearServerErrors();
  }

	onChangeInput = (field, value) => {
		this.setState({[field]: value});
  }

  validateForm = () => {
    const { login, password } = this.props;
    if ((login.length < 5) || (password.length < 5)) {
      this.setState({validError: true});
      return true;
    }
    return false;
  }
  
  onSubmitForm = () => {
    const { onSubmit, login, password } = this.props;
    const validationError = this.validateForm();
    this.setState({ formWasSent: true });
    if (!validationError) onSubmit(login, password);
  }

  clearErrors = () => {
    const { clearServerErrors } = this.props;
    clearServerErrors();
    this.setState({ validError: false });
  }

  getErrorText = () => {
    const { login, password, serverError, loginError } = this.props;
    const { validError } = this.state;
    switch(true) {
      case loginError:
        return 'Неверный логин или пароль';
      case serverError:
        return 'Что-то пошло не так';
      case validError:
        switch(true){
          case ((login.length === 0) && (password.length === 0)):
            return  'Введите логин и пароль';
          case ((login.length !== 0) && (password.length === 0)):
            return 'Введите пароль';
          case ((login.length === 0) && (password.length !== 0)):
            return 'Введите логин';
          case ((login.length < 5) || (password.length < 5)):
            return 'Логин или пароль менее 5 символов';
          default:
            return 'Неверный логин или пароль';
        }
      default:
        return 'Что-то пошло не так';
    }
  }

  render() {
    const { login, password, serverError, loginError, editLogin, editPassword } = this.props;
    const { formWasSent, validError } = this.state;
    const loginRowClass = classnames({
      'login-row': true,
      'error': loginError || (formWasSent && (login.length < 5)),
    });

    const passwordRowClass = classnames({
      'login-row': true,
      'pass': true,
      'error': loginError || (formWasSent && (password.length < 5)),
    });

    const errorText = this.getErrorText();

    return (
      <div className="ext-page-wrap login-wrap">
        {/* Модальное окно для подтверждения номера телефона по коду */}
        {/* Получает все необходимые свойства внутри */}
        <AuthPhoneModal />
        <div className="login-form">
          <div className="login-logo" />
          { serverError || loginError || validError ? (
          <div className="login-error">{errorText}</div>
          ) : false}
          <div className={loginRowClass}>
            <label htmlFor="">Логин</label>
            <input
              id="login"
              type="text"
              value={login}
              onChange={(e) => editLogin(e.target.value)}
              onFocus={this.clearErrors}
            />
          </div>
          <div className={passwordRowClass}>
            <label htmlFor="">Пароль</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => editPassword(e.target.value)}
              onFocus={this.clearErrors}
            />
          </div>
          <button
            type="button"
            className="btn btn-green btn-login"
            onClick={() => this.onSubmitForm()}
          >
            Войти
          </button>
        </div>
        <Link to={'/license'} className="license-link">Лицензии</Link>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireUnauth(LoginPage));
